(function Module() {
	'use strict';

    mySynch.filter('tableSortableFilter', ['$filter', function($filter) {
        return function (input, filter) {
            if (input == Infinity) return null;

            if(_.isUndefined(input) || _.isNull(input) || _.isEqual(input,"")){return null;}
            
            var digits = 2;
            
            if (filter.indexOf(':') > -1) {
                digits = parseInt(filter.split(':')[1].trim());
                filter = filter.split(':')[0].trim();
            }
            
            switch(filter) {
                case 'text':
                return input;
                case 'number':
                return $filter(filter)(input, digits);
                case 'percentage':
                return (_.isEqual(_.trim($filter('number')(input, digits) + '%'),"%"))? "" : $filter('number')(input, digits) + '%';
                case 'dateTime':
                return input;
                default:
                return input;
            }
        };
    }]);

})();